export default function ArrowIcon(props) {
  return (
    <svg width={14} height={16} viewBox="0 0 14 16" fill="none" {...props} >
      <path d="M6.15 15a.85.85 0 0 0 1.7 0h-1.7ZM7.601.399a.85.85 0 0 0-1.202 0l-5.41 5.41A.85.85 0 1 0 2.193 7.01L7 2.202l4.808 4.808a.85.85 0 0 0 1.202-1.202L7.601.4ZM7.85 15V1h-1.7v14h1.7Z" />
    </svg>
  );
}
